import React, { FC } from 'react';
import { Button } from 'components';
import { CloseOutlined } from '@ant-design/icons';
import { Col, Drawer, Row } from 'antd';
import { WebsiteDataType } from 'feature/brandTabs/pricingAndSuppliers/pricing/edit/WebsiteItemCard';
import { WebsitePricingCard } from 'feature/brandTabs/pricingAndSuppliers/pricing/WebsitePricingCard';

interface IAllWebsiteDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data: WebsiteDataType[];
}

export const AllWebsiteDrawer: FC<IAllWebsiteDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={onExpand}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Competitor Pricing'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={onExpand} type="text" />
      </div>
      <Row gutter={[6, 6]}>
        {data?.map((_website: any, i: number) => (
          <Col key={i} span={24}>
            <WebsitePricingCard website={_website} />
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
